export class PagedList<T> {
  public pageCount: number = 0;
  public pageIndex: number = 0;
  public pageSize: number = 0;
  public totalCount: number = 0;
  public list!: T[];
}
